var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconLinkSimpleHorizontal = function SvgIconLinkSimpleHorizontal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 8.5a3.5 3.5 0 1 0 0 7h3.75a1 1 0 1 1 0 2H6a5.5 5.5 0 0 1 0-11h3.75a1 1 0 1 1 0 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5 12a1 1 0 0 1 1-1h9a1 1 0 1 1 0 2h-9a1 1 0 0 1-1-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.25 6.5a1 1 0 1 0 0 2H18a3.5 3.5 0 1 1 0 7h-3.75a1 1 0 1 0 0 2H18a5.5 5.5 0 0 0 0-11z"
  }))));
};
export default SvgIconLinkSimpleHorizontal;